<template>
  <div class="recordPage">
    <div class="recordBg">
      <div class="record">
        <div class="recordC" @scroll="handleScroll">
          <div class="recordScroll">
            <template v-for="(item, index) in recordList">
              <div class="recordLi" :key="index">
                <div class="recordTd" style="width: 21%">
                  {{ item.date }}
                </div>
                <div class="recordTd" style="width: 29%">
                  {{ item.moneyType }}
                </div>
                <div class="recordTd" style="width: 18%; color: #d62123">
                  {{ item.money }}
                </div>
                <div class="recordTd" style="width: 29%">
                  <p
                    :class="[
                      {
                        'status-ing': item.status != '派发中',
                        'status-sended': item.status == '派发中',
                      },
                    ]"
                  >
                    {{ item.status }}
                  </p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="backArea" @click="back"></div>
    </div>
  </div>
</template>

<script>
import { getXjhgHistory } from "@/api/index";

export default {
  name: "Record-vue",
  props: {
    vipAccount: String,
  },
  data() {
    return {
      recordList: [],
    };
  },
  mounted() {
    this.recordNum = 1;
    this.recordList = [];
    this.isLoadingMore = false;
    this.hasMore = true;

    if (this.vipAccount) {
      this.historyRecord();
    }
  },

  methods: {
    // 返回抽奖大厅
    back() {
      this.clearRecordTimer();

      this.$emit("back");
    },
    // 红包记录
    historyRecord() {
      if (this.isLoadingMore || !this.hasMore) return;
      this.isLoadingMore = true;

      getXjhgHistory({
        appId: this.$route.query.appId,
        username: this.vipAccount,
        page: this.recordNum,
      }).then((res) => {
        this.recordList.push(...res.data);
        this.recordNum += 1;
        // 如果新数据长度小于pageSize，则说明没有更多数据
        this.hasMore = res.data.length === 10;
        this.isLoadingMore = false;
      });
    },
    // 红包记录滚动
    handleScroll(event) {
      event.preventDefault();

      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 当滚动到底部时加载更多
      if (scrollTop + clientHeight >= scrollHeight - 5 && this.hasMore) {
        this.historyRecord();
      }
    },

    // 清除文字滚动
    clearRecordTimer() {
      clearInterval(this.recordTimer);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.recordPage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 4;

  .recordBg {
    background: url("../assets/images/home/record.png") no-repeat;
    background-size: contain;
    width: 476px;
    height: 626px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .record {
    position: absolute;
    top: 128px;
    left: 10px;

    .recordC {
      width: 394px;
      height: 317px;
      overflow-y: auto;
      position: absolute;
      top: 71px;
      left: 55px;

      .recordScroll {
        width: 100%;

        .recordLi {
          display: flex;
          align-items: center;
          height: 39px;

          .recordTd {
            color: #543230;
            font-size: 14px;
            text-align: center;
          }

          .status-ing {
            padding: 2px 18px;
            background: #f2f4de;
            color: #46922e;
            border-radius: 6px;
            border: 1px solid #46922e;
            display: inline-block;
          }

          .status-sended {
            padding: 2px 18px;
            background: #fcedd6;
            color: #ee7926;
            border-radius: 6px;
            border: 1px solid #ee7926;
            display: inline-block;
          }
        }
      }
    }
  }

  .backArea {
    position: absolute;
    top: 23px;
    right: 0;
    color: #ffffff;
    font-size: 25px;
    cursor: pointer;
    width: 52px;
    height: 52px;
  }

  .turnArea {
    position: absolute;
    bottom: 47px;
    left: 15px;
    width: 510px;
    height: 37px;
    cursor: pointer;
  }
}
</style>
